import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getCategoryNameById } from '../../../selectors/categories';
import { ResourceGridCellWrapper } from './style';

interface StateProps {
    categoryName: string;
}
interface OwnProps {
    id: string;
}

type ResourceOverviewCategoryProps = StateProps & OwnProps;

const ResourceOverviewCategory = ({ categoryName }: ResourceOverviewCategoryProps) => (
    <ResourceGridCellWrapper>{categoryName}</ResourceGridCellWrapper>
);

export default connect(
    createStructuredSelector<{}, OwnProps, StateProps>({
        categoryName: getCategoryNameById,
    })
)(ResourceOverviewCategory);
